export default "<router-outlet></router-outlet>\r\n<!--<app-e5-root></app-e5-root>-->\r\n";